import React, {Component} from 'react';
import {connect} from 'react-redux';
import style from '../css/attracts.css';
import {getText} from '../../../../helpers/localization';
import {ASSETS_URL} from '../../../../constants/endpoints';
import {
    AMERICAN_FOOTBALL_MODULE,
    BASKETBALL_MODULE,
    FOOTBALL_MODULE,
    RACING_MODULE
} from '../../../../constants/identifiers';
import {hasEventTypeRacerNumberUI} from '../../modules/racing/helpers/racersHelper';
import {CSSTransition, TransitionGroup} from 'react-transition-group';
import {getModuleFromEventType} from '../../../../helpers/moduleHelpers';

const mapStateToProps = (state, ownProps) => {
    return {
        events: state.vpp.events,
        selectedEventIndex: state.vpp.selectedEventIndex,
        selectedEventId: state.vpp.selectedEventId,
        games: state.vpp.games,
        selectedGameIndex: state.vpp.selectedGameIndex
    };
};

let biggestNumberOfPlayersToShow = 3;
let numberOfRacersToShow = biggestNumberOfPlayersToShow;
let timeDisplayed = 7;
let lastUpdateTime;
let indexDisplaying = 0;
let eventIndexToDisplay = 0;

//deal with screen width changes
let lastScreenWidth;
let thresholdWidthForTwoPlayersInAttract = 630;
let thresholdWidthForOnePlayersInAttract = 400;

class GameTab extends Component {

    constructor(props) {
        super(props);

        let store = this.props.store;
        let storeData = store.getState();

        this.state = {
            events: storeData.vpp.events,
            selectedEventIndex: storeData.vpp.selectedEventIndex,
            selectedEventId: storeData.vpp.selectedEventId,
            games: storeData.vpp.games,
            selectedGameIndex: storeData.vpp.selectedGameIndex,
            timeSinceFirstDisplayed: 0
        };
        lastUpdateTime = 0;

    }

    _updateTimeLeft() {
        this.setState({
            ...this.state,
            timeSinceFirstDisplayed: this.state.timeSinceFirstDisplayed + 1
        });
    }

    componentDidMount() {
        window.addEventListener('resize', this._setDimensions.bind(this));
        this._setDimensions();

        this.interval = setInterval(this._updateTimeLeft.bind(this), 1000);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this._setDimensions.bind(this));
        clearInterval(this.interval);
    }

    _setDimensions() {

        if (lastScreenWidth === undefined && this.refs.attractsContainer !== undefined) {
            lastScreenWidth = this.refs.attractsContainer.clientWidth

            if (lastScreenWidth < thresholdWidthForOnePlayersInAttract) {
                numberOfRacersToShow = 1;
            } else if (lastScreenWidth < thresholdWidthForTwoPlayersInAttract) {
                numberOfRacersToShow = 2;
            }

        } else if (this.refs.attractsContainer !== undefined) {
            let width = this.refs.attractsContainer.clientWidth;
            if (lastScreenWidth >= thresholdWidthForTwoPlayersInAttract && width < thresholdWidthForTwoPlayersInAttract) {
                numberOfRacersToShow = 2;
            } else if (lastScreenWidth <= thresholdWidthForTwoPlayersInAttract && width > thresholdWidthForTwoPlayersInAttract) {
                numberOfRacersToShow = biggestNumberOfPlayersToShow;
            }

            if (lastScreenWidth >= thresholdWidthForOnePlayersInAttract && width < thresholdWidthForOnePlayersInAttract) {
                numberOfRacersToShow = 1;
            } else if (lastScreenWidth <= thresholdWidthForOnePlayersInAttract && width > thresholdWidthForOnePlayersInAttract) {
                numberOfRacersToShow = 2;
            }

            lastScreenWidth = width;
        }

        this.setState({
            ...this.state
        });
    }

    componentWillReceiveProps(nextProps) {
        let store = nextProps.store;
        let storeData = store.getState();

        let newTimeSinceFirstDisplayed = this.state.timeSinceFirstDisplayed;

        if (storeData.vpp.events[0] !== undefined && ((this.state.selectedEventId !== storeData.vpp.selectedEventId && storeData.vpp.selectedEventId === storeData.vpp.events[0].eventId) || this.state.selectedGameIndex !== storeData.vpp.selectedGameIndex)) {

            indexDisplaying = 0;
            newTimeSinceFirstDisplayed = 0;
            lastUpdateTime = 0;

        }

        if (nextProps && storeData) {
            this.setState({
                ...this.state,
                events: storeData.vpp.events,
                selectedEventIndex: storeData.vpp.selectedEventIndex,
                selectedEventId: storeData.vpp.selectedEventId,
                games: storeData.vpp.games,
                selectedGameIndex: storeData.vpp.selectedGameIndex,
                timeSinceFirstDisplayed: newTimeSinceFirstDisplayed
            });
        }

    }

    //RACERS
    _generateRacersAttract() {
        let store = this.props.store;
        let storeData = store.getState();

        let selectedEvent = storeData.vpp.events[eventIndexToDisplay];
        let sliderRacers;
        let racersDiv;

        if (this.state.events && this.state.events.length > 0 && this.state.events[eventIndexToDisplay].racers && this.state.events[eventIndexToDisplay].racers.length > 0) {
            let racersList = this.state.events[eventIndexToDisplay].racers.slice();
            let totalNumberOfRacers = this.state.events[eventIndexToDisplay].racers.length;

            if (this.state.timeSinceFirstDisplayed - lastUpdateTime > timeDisplayed) {
                lastUpdateTime = this.state.timeSinceFirstDisplayed;
                if (indexDisplaying >= totalNumberOfRacers) {
                    indexDisplaying = indexDisplaying - totalNumberOfRacers + numberOfRacersToShow;
                } else {
                    indexDisplaying = indexDisplaying + numberOfRacersToShow;
                }
            }

            if (indexDisplaying + numberOfRacersToShow > totalNumberOfRacers) {
                racersList = racersList.concat(selectedEvent.racers.slice());
            }

            sliderRacers = racersList.slice(indexDisplaying, indexDisplaying + numberOfRacersToShow);
            let sliderRacersUI = sliderRacers.map((racer, index) => {
                //replace all ',' for ' , '
                let playerLastResults = selectedEvent.lastResults.find(result => result.number.toString() === racer.num.toString()).result;
                let title = '';
                if (playerLastResults === '') {
                    title = getText('NO_LAST_RESULTS', this.props.store);
                } else {
                    title = getText('LAST_RESULTS', this.props.store) + ': ' + playerLastResults.replace(/,/g, ' , ');
                }
                return (<div key={index} className={style.racerContainer}>
                    <div id={'slider_racer_silk_' + racer.num} className={style.racerIconContainer}>
                        {
                            hasEventTypeRacerNumberUI(selectedEvent.eventType)
                                ? (<div id={'slider_racer_number_' + racer.num}
                                        className={style.racerNumber}>{racer.num}</div>)
                                : ''
                        }
                        <img
                            src={`${ASSETS_URL}${storeData.vpp.games[storeData.vpp.selectedGameIndex].assetsPath}/silks/silk${Number(racer.silk) + 1}.png`}
                            className={style.racerIcon} alt={`icon${racer.silk}`}/>
                    </div>
                    <div className={style.racerTextsContainer}>
                        <div className={style.racerNameAndPrice}>{' ' + racer.name + ' $' + racer.oddsFirst}</div>
                        <div className={style.racerPlaces}>{title}</div>
                    </div>
                </div>)
            });

            racersDiv = (<TransitionGroup>
                <CSSTransition key={indexDisplaying} in={true} timeout={(timeDisplayed + 1) * 1000} classNames={{
                    enter: style.racersEnter,
                    enterActive: style.racersEnterActive,
                    exit: style.racersExit,
                    exitActive: style.racersExitActive
                }}>
                    <div key={indexDisplaying} className={style.racersContainer} onClick={() => this._clickAttract()}>
                        <div className={style.racersHorizontalContainer}>
                            {sliderRacersUI}
                        </div>
                    </div>
                </CSSTransition>
            </TransitionGroup>);

        }

        return racersDiv;
    }

    _generateFootballAttract() {
        let selectedEvent = this.state.events[eventIndexToDisplay];
        let footballDiv;
        let sliderFootball
        let title;

        if (selectedEvent.lastResults !== undefined) {
            let lastHomeResults = selectedEvent.lastResults[0].lastHomeResults;
            let lastAwayResults = selectedEvent.lastResults[0].lastAwayResults;
            let headToHeadResults = selectedEvent.headToHeadResults;

            if (this.state.timeSinceFirstDisplayed - lastUpdateTime > timeDisplayed) {
                indexDisplaying = this._getNextFootballIndex();
            }

            if (indexDisplaying < lastHomeResults.length) {
                sliderFootball = lastHomeResults.slice(indexDisplaying, indexDisplaying + numberOfRacersToShow);
                title = selectedEvent.teamOne + ' ' + getText('PREVIOUS_RESULTS', this.props.store);
            } else if (indexDisplaying < lastHomeResults.length + lastAwayResults.length) {
                let auxIndex = indexDisplaying - lastHomeResults.length;
                sliderFootball = lastAwayResults.slice(auxIndex, auxIndex + numberOfRacersToShow);
                title = selectedEvent.teamTwo + ' ' + getText('PREVIOUS_RESULTS', this.props.store);
            } else {
                let auxIndex = indexDisplaying - lastHomeResults.length - lastAwayResults.length;
                sliderFootball = headToHeadResults.slice(auxIndex, auxIndex + numberOfRacersToShow);
                title = selectedEvent.title + ' ' + getText('PREVIOUS_RESULTS', this.props.store);
            }

        }

        sliderFootball = sliderFootball.map((match, index) => <div key={index} className={style.matchContainer}>
            <div className={style.matchTextsContainer}>
                <div className={style.match}>{match.match}</div>
                <div className={style.matchResult}>{match.result}</div>
            </div>
        </div>);

        footballDiv = (<TransitionGroup>
            <CSSTransition key={indexDisplaying} in={true} timeout={(timeDisplayed + 1) * 1000} classNames={{
                enter: style.racersEnter,
                enterActive: style.racersEnterActive,
                exit: style.racersExit,
                exitActive: style.racersExitActive
            }}>
                <div key={indexDisplaying} className={style.matchesContainer} onClick={() => this._clickAttract()}>
                    <div className={style.matchTitleContainer}>
                        <div className={style.matchTitle}>{title}</div>
                    </div>
                    <div className={style.matchesHorizontalContainer}>{sliderFootball}</div>
                </div>
            </CSSTransition>
        </TransitionGroup>);

        return footballDiv;
    }

    _getNextFootballIndex() {
        let selectedEvent = this.state.events[eventIndexToDisplay];
        let lastHomeResults = selectedEvent.lastResults[0].lastHomeResults;
        let lastAwayResults = selectedEvent.lastResults[0].lastAwayResults;
        let headToHeadResults = selectedEvent.headToHeadResults;

        let totalNumberOfFootballResults = lastHomeResults.length + lastAwayResults.length + headToHeadResults.length;

        lastUpdateTime = this.state.timeSinceFirstDisplayed;

        //this logic ensures that the index jumps always to the start of the next list
        let lhrL = lastHomeResults.length;
        let lhrLarL = lastHomeResults.length + lastAwayResults.length;
        if (indexDisplaying <= (lhrL - 1)) {
            if (indexDisplaying + numberOfRacersToShow > lhrL) {
                indexDisplaying = lhrL;
            } else {
                indexDisplaying = indexDisplaying + numberOfRacersToShow;
            }
        } else if (indexDisplaying <= (lhrLarL - 2)) {
            if (indexDisplaying + numberOfRacersToShow > lhrLarL) {
                indexDisplaying = lhrLarL;
            } else {
                indexDisplaying = indexDisplaying + numberOfRacersToShow;
            }
        } else {
            indexDisplaying = indexDisplaying + numberOfRacersToShow;
        }

        if (indexDisplaying >= totalNumberOfFootballResults) {
            indexDisplaying = 0;
        }

        return indexDisplaying;
    }

    _generateAttract() {
        let store = this.props.store;
        let storeData = store.getState();
        let selectedEvent = storeData.vpp.events[eventIndexToDisplay];
        if (selectedEvent !== undefined && selectedEvent.eventType !== undefined && selectedEvent.lastResults !== undefined) {
            let module = getModuleFromEventType(selectedEvent.eventType);
            switch (module) {
                case RACING_MODULE:
                    //if there are no last Results for any of the races there is no need to display the attracts
                    if (selectedEvent.lastResults.filter(racer => racer.result !== '').length === 0)
                        return;

                    return this._generateRacersAttract();
                case FOOTBALL_MODULE:
                case BASKETBALL_MODULE:
                case AMERICAN_FOOTBALL_MODULE:
                    //if there is no results for football there is no need to display the attracts
                    if (selectedEvent.lastResults[0].lastAwayResults.length === 0 && selectedEvent.lastResults[0].lastHomeResults.length === 0 && selectedEvent.headToHeadResults.length === 0)
                        return;

                    return this._generateFootballAttract();
                default:
                    return;
            }
        }
    }

    _nextRacersInAttract() {
        let totalNumberOfRacers = this.state.events[eventIndexToDisplay].racers.length;
        if (indexDisplaying >= totalNumberOfRacers) {
            indexDisplaying = indexDisplaying - totalNumberOfRacers + numberOfRacersToShow;
        } else {
            indexDisplaying = indexDisplaying + numberOfRacersToShow;
        }
        lastUpdateTime = this.state.timeSinceFirstDisplayed;
        this.setState({
            ...this.state,
            timeSinceFirstDisplayed: this.state.timeSinceFirstDisplayed
        });
    }

    _nextMatchesInAttract() {
        indexDisplaying = this._getNextFootballIndex();

        this.setState({
            ...this.state,
            timeSinceFirstDisplayed: this.state.timeSinceFirstDisplayed
        });
    }

    _clickAttract() {
        let store = this.props.store;
        let storeData = store.getState();
        let selectedEvent = storeData.vpp.events[eventIndexToDisplay];
        if (selectedEvent !== undefined && selectedEvent.eventType !== undefined && selectedEvent.lastResults !== undefined) {
            let module = getModuleFromEventType(selectedEvent.eventType);
            switch (module) {
                case RACING_MODULE:
                    return this._nextRacersInAttract();
                case FOOTBALL_MODULE:
                case BASKETBALL_MODULE:
                case AMERICAN_FOOTBALL_MODULE:
                    return this._nextMatchesInAttract();
                default:
                    return;
            }
        }
    }

    render() {

        return (<div ref="attractsContainer" className={style.attractsContainer}>
            {this._generateAttract()}
        </div>);
    }
}

export default connect(mapStateToProps)(GameTab);


// WEBPACK FOOTER //
// ./src/ui-modules/simplified/sharedComponents/components/attracts.js